import { Box, Grid, Stack, TextField, Typography, useTheme } from '@mui/material'
import TaskDrawerRichText from './TaskDrawerRichText'

const TaskDescription = ({
  addtlNotes,
  taskAddtlNotes,
  onChange,
  localDetails,
  taskDetails,
  editing,
}: {
  addtlNotes: string
  taskAddtlNotes?: string
  onChange: (field: string, newValue: any) => void
  localDetails?: string
  taskDetails?: string
  editing?: boolean
}) => {
  const theme = useTheme()
  const handleAddtlNotesChange = (newValue: string) => {
    onChange('addtlNotes', newValue)
  }

  // Helper to strip HTML tags for plain text display
  const stripHtml = (html: string) => {
    if (!html) return ''
    const tmp = document.createElement('div')
    tmp.innerHTML = html
    return tmp.textContent || tmp.innerText || ''
  }

  return (
    <Grid item xs={12} md={12} sx={{ height: '100%', overflow: 'auto' }}>
      <Stack
        sx={{
          width: '100%',
          mb: 0,
          p: 1,
          gap: 2,
          height: 'auto',
        }}
      >
        {/* Details Field */}
        <Box>
          <Typography variant="subtitle2" color="textSecondary" sx={{ mb: 0.5, textAlign: 'left' }}>
            Details
          </Typography>
          {editing ? (
            <TextField
              size="small"
              fullWidth
              value={localDetails ?? ''}
              onChange={e => onChange('details', e.target.value)}
              placeholder="Short summary (e.g., Q1 campaign scaling)"
              InputLabelProps={{ shrink: true }}
              sx={{
                '& .MuiInputBase-input::placeholder': {
                  opacity: 0.6,
                  fontStyle: 'italic',
                  textAlign: 'left',
                },
                '& .MuiOutlinedInput-root': {
                  height: '36px',
                },
              }}
            />
          ) : (
            <Typography
              sx={{
                color: localDetails ? theme.palette.text.primary : theme.palette.text.secondary,
                fontStyle: localDetails ? 'normal' : 'italic',
                minHeight: '24px',
                py: 0.5,
                textAlign: 'left',
              }}
            >
              {localDetails || 'No details provided'}
            </Typography>
          )}
        </Box>

        {/* Description Field */}
        <Box sx={{ flex: 1, display: 'flex', flexDirection: 'column', minHeight: 0 }}>
          <Typography variant="subtitle2" color="textSecondary" sx={{ mb: 0.5, textAlign: 'left' }}>
            Description
          </Typography>
          {editing ? (
            <Box sx={{ flex: 1, minHeight: '150px' }}>
              <TaskDrawerRichText content={addtlNotes} onContentChange={handleAddtlNotesChange} minHeight="150px" />
            </Box>
          ) : (
            <Box
              sx={{
                flex: 1,
                minHeight: '100px',
                p: 1,
                borderRadius: 1,
                overflow: 'auto',
                border: '1px solid',
                borderColor: 'text.secondary',
              }}
            >
              {addtlNotes ? (
                <Box
                  dangerouslySetInnerHTML={{ __html: addtlNotes }}
                  sx={{
                    '& p': { margin: 0, marginBottom: 1, textAlign: 'left' },
                    '& ul, & ol': { marginTop: 0, marginBottom: 1, paddingLeft: 2 },
                    bgcolor: 'transparent',
                  }}
                />
              ) : (
                <Typography
                  sx={{
                    color: theme.palette.text.secondary,
                    fontStyle: 'italic',
                  }}
                >
                  No description provided
                </Typography>
              )}
            </Box>
          )}
        </Box>
      </Stack>
    </Grid>
  )
}
export default TaskDescription
